import { AvailableDeliveryModesResponse } from '../../@types';

import type { ShippingModel } from 'core';

/**
 * Reseller Available Delivery Modes Presenter
 *
 */
export function availableDeliveriesPresenter(
  payload: AvailableDeliveryModesResponse,
): ShippingModel['data'] {
  const defaultDelivery = {
    distributionCenterCode: payload.data.receive.list[0].distributionCenterCode,
    address: payload.data.receive.list[0].address,
    isWithdrawalCenter: false,
  };

  const hasWithdrawal = payload.data.withdraw?.list.length;
  const withdrawObject = hasWithdrawal
    ? [
        {
          code: payload.data.withdraw?.list[0].businessModelCode,
          deliveries: payload.data.withdraw.list.map((delivery) => ({
            distributionCenterCode: delivery.distributionCenterCode,
            address: delivery.address,
            isWithdrawalCenter: true,
          })),
        },
      ]
    : [];

  return {
    default: {
      code: payload.data.receive.list[0].businessModelCode,
      delivery: defaultDelivery,
    },
    availables: withdrawObject,
  };
}
